export default function Scatter_Plot() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Scatter_Plot</h1>
      <p>Content for Scatter_Plot goes here.</p>
    </div>
  );
}